

import { useState } from "react";
import Config from "../../../Config";
import Invoice from "./Invoice";

 


function PayView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);  
    }


    var tab1 = " m_item ";
  
 

    if(props.mainView.viewSelected == "invoice") tab1 = tab1 + " selected";
 
 

    var subMenu = <div className="submenu">
            <div className={tab1} module="pay" view="invoice" id="" onClick={props.mainView.quickGo} > { props.userData.dic.mInvoices} </div>        
    </div>
 
 

    if(props.mainView.viewSelected == 'invoice')
    {
        document.title = props.userData.dic.mInvoices; 

        return (
            <div className="econtent ">                           
          
                   {subMenu} 
                    <Invoice  userData={props.userData}  mainView={props.mainView}  />                  
             </div>
        )
    }

            

    return (
        <div className="econtent ">
             {props.mainView.viewSelected}
        </div>
    );
}

export default PayView ;